// Translations
import form from '../sections/form/translations/en'

// Translation: Register > Landing (English)
export default Object.freeze({
	sections: { form }
})
